import { withRX } from '@devexperts/react-kit/dist/utils/with-rx2';
import cn from 'classnames';
import * as React from 'react';
import { Button } from 'reactstrap';
import { from, merge } from 'rxjs';
import { distinctUntilChanged, filter, map, pluck, switchMap } from 'rxjs/operators';
import { readFiles } from '../utils/axios';
import { isDefined } from '../utils/object.utils';
import pdfIcon from '../assets/images/pdf-icon-square.svg';
import theme from './AttachmentPreview.module.scss';
export var AttachmentPreviewComponent = React.memo(function (_a) {
    // const [dataUrl, setDataUrl] = useState<string | undefined>();
    var className = _a.className, file = _a.file, id = _a.id, fileData = _a.fileData, onRemove = _a.onRemove;
    // useEffect(() => {
    // readFiles([file]).then(file)
    // }, [file]);
    var isPdf = file === null || file === void 0 ? void 0 : file.type.toLowerCase().includes('pdf');
    var thumb = isPdf ? (React.createElement("img", { className: cn(theme.img, theme.img_pdf), src: pdfIcon })) : (fileData && React.createElement("img", { className: theme.img, src: fileData.data }));
    return (React.createElement("div", { id: id, className: cn(theme.container, className) },
        thumb,
        React.createElement("span", { className: theme.name }, file ? file.name : fileData ? fileData.name : 'Attachment'),
        onRemove && (React.createElement(Button, { color: "link", className: theme.remove, onClick: onRemove },
            React.createElement("i", { className: cn(theme.remove__icon, 'material-icons') }, "cancel")))));
});
export var AttachmentPreviewContainer = function (Target) {
    return withRX(Target)((function (fullProps$) {
        var props$ = fullProps$;
        var files$ = props$.pipe(filter(function (props) { return !props.fileData; }), pluck('file'), filter(isDefined), distinctUntilChanged(), switchMap(function (file) { return from(readFiles([file])); }), map(function (files) { return files[0]; }));
        var fileDatas$ = props$.pipe(pluck('fileData'), filter(isDefined), distinctUntilChanged());
        return {
            props: {
                fileData: merge(fileDatas$, files$),
            },
        };
    }));
};
export var AttachmentPreview = AttachmentPreviewContainer(AttachmentPreviewComponent);
//# sourceMappingURL=AttachmentPreview.js.map